export default __webpack_public_path__ + "static/media/chat-icon4.3fe49f04.svg";